import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}(); // FHT Swagger jQuery client V2

/* eslint-disable */


import { BaseApi } from "./api";

var CmsApiApi =
/** @class */
function (_super) {
  __extends(CmsApiApi, _super);

  function CmsApiApi() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.cmsApiAnalysisPhoneNumber = function (p) {
      var localVarPath = '/api/cms/_analysisPhoneNumber';

      _this.r(p, ["model"]);

      var bodyDict = p["model"];
      var _p = p;
      delete _p["model"];
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.cmsApiAutoCompleteCustomPages = function (p) {
      var localVarPath = '/api/cms/autocompletecustomPages';

      _this.r(p, ["companyId", "q"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiAutoCompleteProductsAsync = function (p) {
      var localVarPath = '/api/cms/autoCompleteProducts';

      _this.r(p, ["model.companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiCmsSettingByCompanyId = function (p) {
      var localVarPath = '/api/cms/settings';

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetAllArticleType = function (p) {
      var localVarPath = '/api/cms/allarticletype';

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetAllCompanyCustomerServicesByCompanyIdAsync = function (p) {
      var localVarPath = '/api/cms/companyallcustomerservices';

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetAllCompanyMembersByCompanyId = function (p) {
      var localVarPath = '/api/cms/companyallmembers';

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetAllCompanyMembersCached = function (p) {
      var localVarPath = '/api/cms/companymemberusers';

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetArticleType = function (p) {
      var localVarPath = '/api/cms/articletype';

      _this.r(p, ["articleTypeId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetArticlesByIds = function (p) {
      var localVarPath = '/api/cms/batcharticles';

      _this.r(p, ["articleIds"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetArticlesDetail = function (p) {
      var localVarPath = '/api/cms/article';

      _this.r(p, ["articleId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetArticlesOfArticleTypeAsync = function (p) {
      var localVarPath = '/api/cms/articlesoftype';

      _this.r(p, ["companyId", "articleTypeId", "q", "args.offset", "args.limit"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetCmsConfig = function (p) {
      var localVarPath = '/api/cms/cmsConfig';

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetCmsTagCachedAsync = function (p) {
      var localVarPath = '/api/cms/cmstag';

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetCompanyAllArticleIdsAsync = function (p) {
      var localVarPath = '/api/cms/getcompanyallarticleids';

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetCompanyAllProductIdsAsync = function (p) {
      var localVarPath = '/api/cms/getcompanyallproductids';

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetCompanyByCompanyId = function (p) {
      var localVarPath = '/api/cms/{companyId}'.replace('{' + 'companyId' + '}', String(p["companyId"]));

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetCompanyByDomainAsync = function (p) {
      var localVarPath = '/api/cms/getByDomain';

      _this.r(p, ["domain"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetCompanyDetail = function (p) {
      var localVarPath = '/api/cms/company';

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetCompanyMembersOfCompanyId = function (p) {
      var localVarPath = '/api/cms/{companyId}/companyMembers'.replace('{' + 'companyId' + '}', String(p["companyId"]));

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetCompanyMultiProductsCached = function (p) {
      var localVarPath = '/api/cms/multiProducts';

      _this.r(p, ["companyId", "productIds"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetCompanyProductsWithTagAsync = function (p) {
      var localVarPath = '/api/cms/getcompanyproductswithtag';

      _this.r(p, ["companyId", "productTagType", "args.top"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetCompanyRecommandProductAsync = function (p) {
      var localVarPath = '/api/cms/getCompanyRecommandProduct';

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetCompanyWapAdvertsAsync = function (p) {
      var localVarPath = '/api/cms/getCompanyWapAdverts';

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetCompanyWapBackgroundAsync = function (p) {
      var localVarPath = '/api/cms/getCompanyWapBackground';

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetCompanyWapBannersAsync = function (p) {
      var localVarPath = '/api/cms/getCompanyWapBanners';

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetCustomCategoriesByIdsCachedAsync = function (p) {
      var localVarPath = '/api/cms/batchCustomCategories';

      _this.r(p, ["companyId", "customCategoryIds"]);

      var bodyDict = p["customCategoryIds"];
      var _p = p;
      delete _p["customCategoryIds"];
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetCustomPageAsync = function (p) {
      var localVarPath = '/api/cms/customPages';

      _this.r(p, ["customPageId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetCustomerServicesOfCompanyId = function (p) {
      var localVarPath = '/api/cms/{companyId}/customerServices'.replace('{' + 'companyId' + '}', String(p["companyId"]));

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetEarliestProductsByCompanyIdAsync = function (p) {
      var localVarPath = '/api/cms/earliestProducts';

      _this.r(p, ["companyId", "args.top"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetGroupProductsOfCustomCategoriesPerCompanyAsync = function (p) {
      var localVarPath = '/api/cms/groupProductsOfCustomCategoriesPerCompany';

      _this.r(p, ["companyId", "customCategoryIds"]);

      var bodyDict = p["customCategoryIds"];
      var _p = p;
      delete _p["customCategoryIds"];
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetMyCompanyMember = function (p) {
      var localVarPath = '/api/cms/mycompanymember';

      _this.r(p, ["authenticatedUserId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetMyCompanyMembers = function (p) {
      var localVarPath = '/api/cms/mycompanymembers';

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetNextArticleAsync = function (p) {
      var localVarPath = '/api/cms/getnextarticle';

      _this.r(p, ["companyId", "articleId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetNextProduct = function (p) {
      var localVarPath = '/api/cms/nextproduct';

      _this.r(p, ["productId", "companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetPreProduct = function (p) {
      var localVarPath = '/api/cms/preproduct';

      _this.r(p, ["productId", "companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetPresetArticleType = function (p) {
      var localVarPath = '/api/cms/presetarticletype';

      _this.r(p, ["companyId", "presetPage"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetPresetArticlesAsync = function (p) {
      var localVarPath = '/api/cms/presetarticles';

      _this.r(p, ["companyId", "presetPage", "args.offset", "args.limit"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetPrevArticleAsync = function (p) {
      var localVarPath = '/api/cms/getprevarticle';

      _this.r(p, ["companyId", "articleId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetProductDetail = function (p) {
      var localVarPath = '/api/cms/productDetail';

      _this.r(p, ["productId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetProductsByCustomCategoryIdsAsync = function (p) {
      var localVarPath = '/api/cms/getProductsByCustomCategoryIds';

      _this.r(p, ["companyId", "customCategoryIds"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetProductsByIds = function (p) {
      var localVarPath = '/api/cms/batchproductsasync';

      _this.r(p, ["ids"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetProductsInCms = function (p) {
      var localVarPath = '/api/cms/products';

      _this.r(p, ["companyId", "args.currPage", "args.limit"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetRecentTopicPostsOfCompany = function (p) {
      var localVarPath = '/api/cms/recentTopicPostsOfCompany';

      _this.r(p, ["myCompanyId", "args.limit"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetRecommendProducts = function (p) {
      var localVarPath = '/api/cms/recommendProducts';

      _this.r(p, ["companyId", "args.top"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetRelatedProductsAsync = function (p) {
      var localVarPath = '/api/cms/relatedproducts';

      _this.r(p, ["categoryId", "companyId", "productId", "args.top"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetRelatedTopicpostsAsync = function (p) {
      var localVarPath = '/api/cms/relatedtopicposts';

      _this.r(p, ["q", "companyId", "args.top"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetSingleCustomCategoryAsync = function (p) {
      var localVarPath = '/api/cms/usedSingleCustomCategory';

      _this.r(p, ["companyId", "customCategoryId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetSingleSystemCategoryAsync = function (p) {
      var localVarPath = '/api/cms/usedSingleSystemCategory';

      _this.r(p, ["systemCategoryId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetSystemCategoriesByIdsCachedAsync = function (p) {
      var localVarPath = '/api/cms/batchSystemCategories';

      _this.r(p, ["systemCategoryIds"]);

      var bodyDict = p["systemCategoryIds"];
      var _p = p;
      delete _p["systemCategoryIds"];
      return _this.ajax("POST", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetTopicPostDetail = function (p) {
      var localVarPath = '/api/cms/gettopicpostdetail';

      _this.r(p, ["id"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiGetUsedSystemCategoriesOfCompanyAsync = function (p) {
      var localVarPath = '/api/cms/allUsedSystemCategoriesOfCompany';

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiPreviewTemplateCmsSettingByCompanyId = function (p) {
      var localVarPath = '/api/cms/previewtemplatecmssettings';

      _this.r(p, ["companyId", "templateId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiRelatedAsync = function (p) {
      var localVarPath = '/api/cms/relatedarticle';

      _this.r(p, ["companyId", "title", "args.top"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiSearchAllUsedCustomCategoriesOfCompanyAsync = function (p) {
      var localVarPath = '/api/cms/searchUsedCustomCategoriesOfCompany';

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    _this.cmsApiSearchAllUsedSystemCategoriesOfCompanyAsync = function (p) {
      var localVarPath = '/api/cms/searchUsedSystemCategoriesOfCompany';

      _this.r(p, ["companyId"]);

      var bodyDict = undefined;
      return _this.ajax("GET", localVarPath, p, bodyDict);
    };

    return _this;
  }

  return CmsApiApi;
}(BaseApi);

export { CmsApiApi };